module.exports = __webpack_public_path__ + "media/images/lb/134-fea9d508a60d44d9750b1147dc84dae3.svg";